// extracted by mini-css-extract-plugin
export var details = "_e0-0";
export var inspectorPopover = "_e0-1";